import React, { useRef } from "react";
import ReactToPrint from "react-to-print";
import { Liste } from "./Liste";
import IconButton from '@mui/material/IconButton';
import PrintIcon from '@mui/icons-material/Print';
import LoadingButton from "@mui/lab/LoadingButton";


const ComponentToPrint = React.forwardRef((props: any, ref: any) => {
  return (
    <div
      style={{
        backgroundColor: "transparent",
        height: "100%",
      }}
      ref={ref}
    >
      <Liste />
    </div>
  );
});

export const PrintEtat = () => {
  const componentRef: any = useRef(null);
  return (
    <div>
      {/* <ReactToPrint
        trigger={() => (
          <LoadingButton
          loadingPosition="start"
          startIcon={<PrintIcon />}
          variant="outlined"
          size="small"
        >
          Imprimer
        </LoadingButton>
          )}
        content={() => componentRef.current}
      /> */}
      <div style={{ display: "none" }}>
        <ComponentToPrint ref={componentRef} />
      </div>
    </div>
  );
};
